import type { dedupeIntegration } from '@sentry/react';

type Integration = ReturnType<typeof dedupeIntegration>;

// Preserve repeated diagnostic occurrences without disabling error deduplication.
export const preserveDiagnosticOccurrences = (integration: Integration): Integration => {
    if (integration.name !== 'Dedupe' || !integration.processEvent) return integration;
    const processEvent = integration.processEvent.bind(integration);
    return {
        ...integration,
        processEvent(event, hint, client) {
            if (event.tags?.diagnostic_event) return event;
            return processEvent(event, hint, client);
        },
    };
};
